// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
export const AUTH_ROUTE = 'auth';
export const LOGOUT_ROUTE = 'logout';
export const ACCOUNT_SETTINGS_ROUTE = 'account-settings';
export const IAM_ROUTE = 'iam';

const HTTP_PORT = '80';
const HTTPS_PORT = '443';

export function getURL(route: string, location: Location) {
  const port = location.port;
  const hasStandardPort = port === HTTPS_PORT || port === HTTP_PORT || port === '';
  const redirectPort = hasStandardPort ? '' : `:${port}`;
  return `${location.protocol}//${location.hostname}${redirectPort}/${route}`;
}

export function getAuthURL(location: Location) {
  return getURL(AUTH_ROUTE, location);
}

export function getAuthURLFromWindow() {
  return getAuthURL(window.location);
}

export function parseQueryParams(url: Location): { [key: string]: any } {
  const query = url.search.substr(1);
  const result: { [key: string]: any } = {};
  query.split('&').forEach(function(part: string) {
    const item = part.split('=');
    result[item[0]] = decodeURIComponent(item[1]);
  });
  return result;
}



// WEBPACK FOOTER //
// ./src/app/core/utilities/path.ts